import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from 'projects/components/pay-icon/icon.component';
import { IconNames } from 'projects/components/pay-icon/IconNames';

@Component({
  selector: 'pay-login-reset-requested',
  imports: [IconComponent, TranslateModule],
  templateUrl: './reset-requested.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetRequestedComponent {
  private readonly _router = inject(Router);

  email: string = '';

  constructor() {
    const navigation = this._router.currentNavigation();
    if (navigation?.extras.state) {
      this.email = navigation.extras.state['email'];
    }

    if (this.email === null || this.email === undefined || this.email === '') {
      this.returnToLogin();
    }
  }

  returnToLogin() {
    this._router.navigateByUrl('/').then();
  }

  protected readonly IconNames = IconNames;
}
